import { useQuery } from '@tanstack/react-query'
import { getCase } from '../api'

export const caseDetailQueryKey = (id: string) => ['cases', 'detail', id] as const

export function useCaseDetail(id: string | undefined) {
  return useQuery({
    queryKey: ['cases', 'detail', id ?? ''] as const,
    queryFn: () => getCase(id!),
    enabled: id !== undefined && id !== '',
    staleTime: 30_000,
  })
}
